//#region src/utils/object-keys-conversion.ts
var objectKeysToSnakeCase = (obj) => {
	if (typeof obj !== "object" || obj === null) return obj;
	if (Array.isArray(obj)) return obj.map((item) => objectKeysToSnakeCase(item));
	const snakeCaseObj = {};
	for (const key in obj) if (Object.prototype.hasOwnProperty.call(obj, key)) {
		const snakeCaseKey = /[A-Z]/.test(key) ? key.replace(/([A-Z0-9]+)/g, "_$1").toLowerCase() : key;
		snakeCaseObj[snakeCaseKey] = objectKeysToSnakeCase(obj[key]);
	}
	return snakeCaseObj;
};
var objectKeysToCamelCase = (obj) => {
	if (typeof obj !== "object" || obj === null) return obj;
	if (Array.isArray(obj)) return obj.map((item) => objectKeysToCamelCase(item));
	const camelCaseObj = {};
	for (const key in obj) if (Object.prototype.hasOwnProperty.call(obj, key)) {
		const camelCaseKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase()).replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
		camelCaseObj[camelCaseKey] = objectKeysToCamelCase(obj[key]);
	}
	return camelCaseObj;
};
//#endregion
export { objectKeysToCamelCase, objectKeysToSnakeCase };

//# sourceMappingURL=object-keys-conversion.js.map